var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPasswordChangeCompIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    rx: 30,
    fill: "white",
    fillOpacity: 0.7
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2200_2856)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.75 67.5H32.5C31.1739 67.5 29.9021 66.9732 28.9645 66.0355C28.0268 65.0979 27.5 63.8261 27.5 62.5V47.5C27.5 46.1739 28.0268 44.9021 28.9645 43.9645C29.9021 43.0268 31.1739 42.5 32.5 42.5H57.5C58.8261 42.5 60.0979 43.0268 61.0355 43.9645C61.9732 44.9021 62.5 46.1739 62.5 47.5V48.75",
    stroke: "#259AF9",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5 55C42.5 55.663 42.7634 56.2989 43.2322 56.7678C43.7011 57.2366 44.337 57.5 45 57.5C45.663 57.5 46.2989 57.2366 46.7678 56.7678C47.2366 56.2989 47.5 55.663 47.5 55C47.5 54.337 47.2366 53.7011 46.7678 53.2322C46.2989 52.7634 45.663 52.5 45 52.5C44.337 52.5 43.7011 52.7634 43.2322 53.2322C42.7634 53.7011 42.5 54.337 42.5 55Z",
    fill: "#259AF9",
    stroke: "#259AF9",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 42.5V32.5C35 29.8478 36.0536 27.3043 37.9289 25.4289C39.8043 23.5536 42.3478 22.5 45 22.5C47.6522 22.5 50.1957 23.5536 52.0711 25.4289C53.9464 27.3043 55 29.8478 55 32.5V42.5",
    stroke: "#259AF9",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5 62.5L57.5 67.5L67.5 57.5",
    stroke: "#259AF9",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2200_2856"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    fill: "white",
    transform: "translate(15 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordChangeCompIcon);
export default __webpack_public_path__ + "static/media/password_change_comp_icon.a25c13b6fab10d4018f7aedc39e98030.svg";
export { ForwardRef as ReactComponent };